import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import IconV2 from '../v2/IconV2.jsx';
import { IoArrowDown } from '@/components/react-icons/main';

const SyncStateLoader = () => {
  const isSyncing = useSelector((state) => state?.workflow?.isSyncing);
  const isUpdating = useSelector((state) => state?.workflow?.isUpdating);
  const isAutosaving = useSelector((state) => state?.ui?.loadState?.workflowAutosave?.isLoading);
  const actualChangesQueueLength = useSelector((state) => state?.workflow?.changesQueue?.length);
  const [changesQueueLength, setChangesQueueLength] = useState(0);

  const isQueued = !isSyncing && actualChangesQueueLength > 0;
  const loaderClass = isQueued ? 'queued' : isUpdating ? 'updating' : isSyncing || isAutosaving ? 'syncing' : 'idle';

  const computedDisplayLength = (!isSyncing ? actualChangesQueueLength : changesQueueLength) || 0;
  const title = isSyncing ? `Syncing ${computedDisplayLength} change${computedDisplayLength?.length === 1 ? '' : 's'}` : `${computedDisplayLength} un-synced change${computedDisplayLength?.length === 1 ? '' : 's'}.`;

  useEffect(() => {
    if (!isSyncing || actualChangesQueueLength > 0) {
      setChangesQueueLength(actualChangesQueueLength);
    }
  }, [actualChangesQueueLength, isSyncing]);

  return (
    <div className={`sync-state-loader ${loaderClass}`} data-title={title}>
      <div className="sync-state-spinner" />
      <IconV2 icon={IoArrowDown} className={'updating-icon'} />
      <div className={'changes'}>{computedDisplayLength || ''}</div>
    </div>
  );
};

export default SyncStateLoader;
